// src/hooks/useSocketConnection.ts
'use client'

import { useEffect, useState } from 'react'
import { Socket } from 'socket.io-client'

export const useSocketConnection = (socket: Socket) => {
  const [isConnected, setConnected] = useState(false)

  useEffect(() => {
    if (socket) {
      socket.on('connect', () => {
        setConnected(true)
      })
      socket.on('disconnect', () => {
        setConnected(false)
      })
    }

    return () => {
      if (socket) {
        socket.off('connect')
        socket.off('disconnect')
      }
    }
  }, [socket])

  return isConnected
}
